import * as React from "react";
const Globe = (props) => (
  <svg
    width={115}
    height={115}
    viewBox="0 0 115 115"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M110.893 57.4998C110.893 71.6605 105.268 85.2411 95.2547 95.2542C85.2416 105.267 71.6609 110.893 57.5003 110.893C43.3396 110.893 29.7589 105.267 19.7458 95.2542C9.73272 85.2411 4.10742 71.6605 4.10742 57.4998M110.893 57.4998C110.893 43.3391 105.268 29.7584 95.2547 19.7453C85.2416 9.73224 71.6609 4.10693 57.5003 4.10693C43.3396 4.10693 29.7589 9.73224 19.7458 19.7453C9.73272 29.7584 4.10742 43.3391 4.10742 57.4998M110.893 57.4998H4.10742"
      stroke="white"
      strokeWidth={8.21429}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M78.0363 57.4998C77.0276 77.0251 69.8358 95.7237 57.5006 110.893C45.1653 95.7237 37.9735 77.0251 36.9648 57.4998C37.9735 37.9745 45.1653 19.2759 57.5006 4.10693C69.8358 19.2759 77.0276 37.9745 78.0363 57.4998Z"
      stroke="white"
      strokeWidth={8.21429}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Globe;
